import React from 'react';
import { IIconProps } from './utils';

export const PencilBubble = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4.75 5C2.67893 5 1 6.67893 1 8.75V15C1 15.6904 1.55964 16.25 2.25 16.25C2.94036 16.25 3.5 15.6904 3.5 15V8.75C3.5 8.05964 4.05964 7.5 4.75 7.5H11.2305C11.9208 7.5 12.5 6.94036 12.5 6.25C12.5 5.55964 11.9208 5 11.2305 5H4.75Z"
      fill={fill}
    />
    <path
      d="M24.75 5C24.0596 5 23.5 5.55964 23.5 6.25C23.5 6.94036 24.0596 7.5 24.75 7.5C25.4404 7.5 26 8.05964 26 8.75V20C26 20.6904 25.4404 21.25 24.75 21.25H19.5355C18.541 21.25 17.5871 21.6451 16.8839 22.3484L14.75 24.4822L12.6161 22.3484C11.9129 21.6451 10.959 21.25 9.96447 21.25H4.75C4.05964 21.25 3.5 20.6904 3.5 20C3.5 19.3096 2.94036 18.75 2.25 18.75C1.55964 18.75 1 19.3096 1 20C1 22.0711 2.67893 23.75 4.75 23.75H9.96447C10.296 23.75 10.6139 23.8817 10.8483 24.1161L12.9822 26.25C13.9585 27.2263 15.5415 27.2263 16.5178 26.25L18.6516 24.1161C18.8861 23.8817 19.204 23.75 19.5355 23.75H24.75C26.8211 23.75 28.5 22.0711 28.5 20V8.75C28.5 6.67893 26.8211 5 24.75 5Z"
      fill={fill}
    />
    <path
      d="M21.513 4.46096L20.539 3.48699C19.8897 2.83767 18.837 2.83767 18.1877 3.48699L17.466 4.20869C17.302 4.37266 17.302 4.6385 17.466 4.80247L20.1975 7.53403C20.3615 7.69799 20.6273 7.698 20.7913 7.53404L21.513 6.81235C22.1623 6.16303 22.1623 5.11028 21.513 4.46096Z"
      fill={fill}
    />
    <path
      d="M8.07218 13.6025L15.6847 5.98993C15.8486 5.82597 16.1145 5.82597 16.2784 5.98993L19.01 8.72152C19.174 8.88548 19.174 9.15133 19.01 9.3153L11.3975 16.9278C11.1654 17.1599 10.8698 17.3181 10.5479 17.3825L7.50244 17.9916C7.20865 18.0504 6.94963 17.7913 7.00839 17.4976L7.61748 14.4521C7.68186 14.1302 7.84007 13.8346 8.07218 13.6025Z"
      fill={fill}
    />
  </svg>
);
